export default class StudentsCheckoutWaitingOney {

  constructor() {
    this.bindEvents();
  }

  bindEvents() {
    // Hide .btn-contact div
    $('.btn-contact').hide();

    // Auto-refresh every 10 seconds
    setInterval(function() {
      location.reload();
    }, 10000);
  }
}